import dayjs from "dayjs";
import { LocalStorageService } from "./local-storage-service.util";
import { FileFormat } from "@/types";

const formattedCurrentDate = dayjs().format("DD.MM.YYYY");

export const getNameFromFileKey = (key: string): string => key.split(".")[0];

export const downloadFile = (blob: Blob, key: string, format: FileFormat) => {
  let exportsCount = 1;
  const usersCsvReportMeta = LocalStorageService.getFileReportMeta(key);

  if (usersCsvReportMeta?.date === formattedCurrentDate) {
    exportsCount = usersCsvReportMeta.count + 1;

    LocalStorageService.setFileReportMeta(key, {
      ...usersCsvReportMeta,
      count: exportsCount,
    });
  } else {
    LocalStorageService.setFileReportMeta(key, {
      date: formattedCurrentDate,
      count: 1,
    });
  }

  const fileName = `${getNameFromFileKey(key)}_${dayjs().format(
    "DD.MM.YYYY",
  )}_${exportsCount}.${format}`;

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
